var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
var SvgLightningBolt = function SvgLightningBolt(props, ref) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    "data-alias": "concern",
    viewBox: "0 0 128 128",
    ref: ref
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M59.34 115c-.57 0-1.14 0-1.72-.58-1.72-.58-2.86-2.9-2.29-4.63l4.59-31.3H24.39a4.81 4.81 0 0 1-4.01-2.31c-.58-1.16-.58-3.48.57-4.64l45.27-56.78a3.7 3.7 0 0 1 5.16-1.16c1.72.58 2.86 2.9 2.29 4.64l-4.01 31.29h34.95a4.81 4.81 0 0 1 4.01 2.31c.58 1.74.58 3.48-.57 4.64l-45.27 56.78c-1.15 1.16-2.3 1.74-3.44 1.74M33.56 69.8H64.5c1.15 0 2.3.59 3.44 1.74.57 1.16 1.14 2.32 1.14 3.48L66.22 95.3l29.22-37.08H64.5c-1.15 0-2.3-.58-3.44-1.74-.57-1.16-1.14-2.32-.57-3.48l2.86-20.28-29.8 37.09z"
  })));
};
var ForwardRef = /*#__PURE__*/forwardRef(SvgLightningBolt);
export default ForwardRef;